import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './app/App'
import reportWebVitals from './reportWebVitals'
import { store } from './store/store'
import ReactDOM from 'react-dom/client';
import 'core-js/features/regexp';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    </React.StrictMode>
)


function clearCachesAndReloadClients(registration: any) {
    return caches.keys().then(cacheNames => {
        return Promise.all(cacheNames.map(cacheName => {
            return caches.delete(cacheName).then(() => {
                console.log(`Cache ${cacheName} deleted.`);
            });
        }));
    }).then(() => {
        console.log('All caches have been cleared.');
        return registration.clients.matchAll({type: 'window'});
    }).then(clients => {
        clients.forEach((client: any) => client.navigate(client.url));
    });
}

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
        .then(registration => {
            if ('caches' in window) {
                console.log('Attempting to clear caches...');
                clearCachesAndReloadClients(registration).catch(error => {
                    console.error('Cache clearing failed, retrying...', error);
                    setTimeout(() => {
                        clearCachesAndReloadClients(registration);
                    }, 3000);
                });
            }
        })
        .catch(error => {
            console.error('Service worker registration failed:', error);
        });
} else {
    console.log('Service Worker and Cache API are not supported in this browser.');
}

try {
    new RegExp("(?<name>\\d+)");
} catch (e) {
    console.warn("Named capture groups are not supported in this environment.");
}
window.onerror = (msg, src, line, col, err) => {
    console.error(`Error in ${src}:${line}:${col} - ${msg}`);
    if (err) console.error(err.stack);
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
